import React from 'react';
import { Link } from 'react-router-dom';
import VideoEmbed from '../../components/VideoEmbed';
import './HomePage.css';

const HomePage = () => {
  return (
    <main>
      <section className="hero">
        <div className="container hero-content">
          <div className="hero-text">
            <h2>Master Agentic AI</h2>
            <p>Learn how to build, deploy, and optimize AI agents for real-world applications</p>
            <Link to="/courses" className="btn-primary">Explore Course</Link>
          </div>
          <div className="hero-image"></div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <h2>Course Features</h2>
          <div className="feature-grid">
            <div className="feature-card">
              <div className="feature-icon feature-icon-video"></div>
              <h3>Video Lectures</h3>
              <p>High-quality video content with expert instructors</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon feature-icon-quiz"></div>
              <h3>Interactive Quizzes</h3>
              <p>Test your knowledge with quizzes after each module</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon feature-icon-project"></div>
              <h3>Hands-on Projects</h3>
              <p>Apply your learning with practical projects</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon feature-icon-certificate"></div>
              <h3>Certification</h3>
              <p>Earn a certificate upon course completion</p>
            </div>
          </div>
        </div>
      </section>

      <section className="course-preview">
        <div className="container">
          <h2>Course Preview</h2>
          <div className="video-container">
            <VideoEmbed 
              videoLink="https://www.youtube.com/embed/F8NKVhkZZWI" 
              title="Introduction to Agentic AI"
              onComplete={() => console.log('Preview video completed')}
            />
          </div>
          <div className="preview-info">
            <h3>Introduction to Agentic AI</h3>
            <p>This preview introduces the fundamental concepts of Agentic AI and outlines what you'll learn throughout the course.</p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default HomePage;
